import { render, staticRenderFns } from "./mailbox-settings-office-hours.vue?vue&type=template&id=1c82867c&scoped=true&"
import script from "./mailbox-settings-office-hours.vue?vue&type=script&lang=ts&"
export * from "./mailbox-settings-office-hours.vue?vue&type=script&lang=ts&"
import style0 from "./mailbox-settings-office-hours.vue?vue&type=style&index=0&id=1c82867c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c82867c",
  null
  
)

export default component.exports